import { Typography, Button } from "@mui/material";
import { tss } from "tss-react";
import ApiUtils from "api/Utils";
import ModalWindow from "components/ModalWindow";
import { updateData } from "services/CacheService";
import { deleteProjectFromCache, getCachedData } from "api/Cache";
import { FoldersActions } from "actions";
import EventsEmitter from "events/EventsEmitter";
import { useSelector } from 'react-redux';
import ConfirmationDialog from "components/ConfirmationDialog";

const useStyles = tss.create(() => ({
    title: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 20,
    },
    confirmationText: {
        fontSize: 14,
        marginBottom: 20,
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        color: "red",
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
}));

type IProps = {
    open: boolean;
    handleClose: (cancelled: boolean) => void;
};

const sendData = (projectId: string, items: string[]) => {
    if (projectId === "") {
        return;
    }
    ApiUtils.remoteDeleteItems(projectId, items.join(" "));
};

export const DeleteItem = (defaultProjects:any[], itemsToDelete?: any[], callback?: () => void, noRefreshList?: boolean) => {
    const items: any = itemsToDelete?.length ? itemsToDelete : FoldersActions.selectedItems;
    const cachedData = getCachedData();
    let entitiesToDelete: any = [];
    const nextFolder = (folder: any) => {
        folder.files.forEach((file: any) => {
            entitiesToDelete.push(file.ID);
        });
        folder.subfolders.forEach((subfolder: any) => {
            entitiesToDelete.push(subfolder.ID);
            nextFolder(subfolder);
        });
    };
    const projects: any = [];
    var pending = items.length;
    items.forEach((itemId: string) => {
        const item = FoldersActions.allEntities.find((entity: any) => entity.ID === itemId);
        if (item) {
            if (item.type === "PROJECT") {
                const deletedProject = cachedData["projectsRef"].find(
                    (projRef: any) => projRef["project_ref"] === itemId
                );
                if (deletedProject && !defaultProjects.includes(deletedProject["project"])) {
                    ApiUtils.remoteDeleteProject(itemId, deletedProject["project"], () => {
                        console.log("successfully deleted project:", itemId);
                        deleteProjectFromCache(itemId);
                        pending--;
                        if (pending === 0) {
                            FoldersActions.reloadCatalog(() => {
                                console.log("done deleting projects");
                                window.alert("done deleting project");
                                EventsEmitter.emit("reloadData", "");
                            });
                        }
                    });
                }
            } else {
                const projectId = item.project;
                if ( defaultProjects.includes(projectId)) return;

                updateData("delete", "entities", projectId, item);
                const catalog = FoldersActions.allCatalogs[item.ID];
                if (catalog && catalog.file_type === "FOLDER") {
                    nextFolder(catalog);
                }
                entitiesToDelete.push(item.ID);
                if (catalog) {
                    const virtuals: any = FoldersActions.getVirtuals(catalog);
                    const virtualsIDs = virtuals.map((object: any) => object["ID"]);
                    entitiesToDelete = entitiesToDelete.concat(virtualsIDs);
                }
                projects[projectId] = entitiesToDelete;
            }
        }
    });
    console.log("entitiesToDelete:", entitiesToDelete);
    Object.entries(projects).forEach((entry: any) => {
        const projectId = entry[0];
        const entitiesToDelete = entry[1];
        sendData(projectId, entitiesToDelete);
    });
    if (!noRefreshList) {
        EventsEmitter.emit("signalr_update", {
            type: "entity_update",
            action: "reload_all",
        });
        EventsEmitter.emit("reloadData", "");
    }

    callback && callback();
};

export default function DeleteItemsPanel(props: IProps) {
    const { classes } = useStyles();
    const { open:openConfirmation } = props;
	const storeAuthData = useSelector((state: any) => state.auth);
    const { defaultProjects } = storeAuthData;

    const handleCancel = () => {
        props.handleClose(false);
    };

    const handleOk = () => {
        DeleteItem(defaultProjects, [], () => {
            props.handleClose(true);
        })
    };
    
    const confirmAction = (object: any) => {
        if (object.status) handleOk();
        else handleCancel();
    };

    return openConfirmation ? (
        <ConfirmationDialog
            open={openConfirmation}
            title="Delete Items"
            msg="This will permanently delete the selected items along with their information in the server. Are you sure
                you want to proceed?"
            confirmAction={confirmAction}
        />
    ) : "";
}